export default __webpack_public_path__ + "static/media/1-Cloudxier-PTSTP.0b480c9f.png";